
import {Component, Prop, Vue} from "vue-property-decorator";
import {getClaimDet, getClaimReason, getDeductionMethod, updateSupplierDeduction} from "@/api/credit-note";

@Component({name: "UpdateSupplierDeduction"})
export default class extends Vue {
  @Prop({ required: false }) private show: boolean;
  @Prop({ default: "" }) private id: string;
  private formItem = [
    {
      label: "供应商",
      prop: "supplierAbb",
      key: "supplierAbb",
      type: "input",
      readonly: true,
    },
    {
      label: "扣款类型",
      prop: "claimReason",
      key: "claimReason",
      type: "cascader",
      options: [],
      placeholder: "请选择扣款类型",
      clearable: true,
      rules: {
        required: true,
        message: "请选择扣款类型",
        trigger: "change",
      },
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "input",
      readonly: true,
    },
    {
      label: "扣款金额",
      prop: "claimAmount",
      key: "claimAmount",
      type: "inputNumber",
      precision: 2,
      placeholder: "请输入扣款金额",
      clearable: true,
      rules: {
        required: true,
        message: "请输入扣款金额",
        trigger: "change",
      },
    },
    {
      label: "协议号码",
      prop: "protocolNumber",
      key: "protocolNumber",
      type: "input",
      placeholder: "请输入协议号码",
      clearable: true,
    },
    {
      label: "对应开票金额",
      prop: "invoicingAmount",
      key: "invoicingAmount",
      type: "input",
      placeholder: "请输入对应开票金额",
      clearable: true,
    },
    {
      label: "扣款比例",
      prop: "deductionRatio",
      key: "deductionRatio",
      type: "input",
      placeholder: "请输入扣款比例",
      clearable: true,
      maxlength: 10,
      unit: "%",
    },
    {
      label: "签约日期",
      prop: "timeOfIssue",
      key: "timeOfIssue",
      type: "datetime",
      format: "yyyy-MM-dd hh:mm:ss",
      placeholder: "请选择签约日期",
      clearable: true,
    },
    {
      label: "抵扣方式",
      prop: "deductionMethod",
      key: "deductionMethod",
      type: "select",
      options: [],
      placeholder: "请选择抵扣方式",
      clearable: true,
      labelKey: "desc",
      valueKey: "name",
      rules: {
        required: true,
        message: "请选择抵扣方式",
        trigger: "change",
      },
    },
    {
      label: "扣款说明",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入扣款说明",
      clearable: true,
    },
  ];
  private formData = {
    supplierAbb: "",
    claimReason: "",
    company: "",
    claimAmount: 0,
    protocolNumber: "",
    invoicingAmount: "",
    deductionRatio: "",
    timeOfIssue: null,
    deductionMethod: "",
    remark: "",
  };

  created() {
    this.init();
  }

  activated() {
    this.init();
  }

  private async init() {
    this.formItem[1].options = await getClaimReason() as any;
    this.formItem[8].options = await getDeductionMethod() as any;
  }

  private async open() {
    const res = await getClaimDet(this.id) as any;
    this.formData = {...res};
  }

  private close() {
    this.$emit("update:show", false);
  }

  private async submit() {
    const params = {
      ...this.formData,
      id: this.id,
    };
    await updateSupplierDeduction(params).then(() => {
      this.close();
      this.$emit("handleSuccess");
    }).catch((err) => console.log(err));
  }

  public change(data) {
    if (data.data.key === "claimReason") {
      this.formData.claimReason = data.data.value[data.data.value.length - 1];
    }
  }
}
